import CourseController from '../../../../../components/diagrams/course.controller';

class ImposingTheStructureController extends CourseController {

  constructor(courseService, helperService, $sce, $anchorScroll, $location, $scope) {
    'ngInject';
    super(courseService, helperService, $sce, $scope, $anchorScroll, $location);
    Object.assign(this, { courseService, helperService, $sce, $anchorScroll, $location});
    this.videoUrl = this.$sce.trustAsResourceUrl('https://player.vimeo.com/video/322179700');
    this.videoId = '708c551f38b343128c1e0910b9dde267';
    this.isUnit = true
    this.exerciseIdsStart = 'diagram1a1-'
  }

}

export default ImposingTheStructureController;



// WEBPACK FOOTER //
// ./client/app/modules/courses/1/1a/imposingTheStructure/imposingTheStructure.controller.js